export default __webpack_public_path__ + "static/media/licenses.88978bd5.txt";